module.exports = __webpack_public_path__ + "assets/fonts/element-icons.535877f5.woff";